import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { select, Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { GoogleMap, MapMarker } from '@angular/google-maps';
import { UiPreloaderComponent } from '@ui';
import { PreloaderColor } from '@enums/shared.enum';
import * as GrantedAccessSelectors from '@states/granted-access/granted-access.selectors';
import { AlertEntry } from '../../../../development/alerts.service';
import { MapModalModels } from '@modals/map-modal/model/map-modal.models';
import { extractPanicCoords } from '../../panic-alert.util';
import MapCoords = MapModalModels.MapCoords;
import { MapProviderModels, UiIfMapProviderDirective, UiMaplibreMapComponent, UiMapPointMarkerPipe } from '@ui';

const PANIC_LOCATION_ZOOM = 15;

@Component({
  selector: 'app-shared-panic-alert',
  templateUrl: './shared-panic-alert.component.html',
  styleUrl: './shared-panic-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    UiIfMapProviderDirective,
    UiMaplibreMapComponent,
    UiMapPointMarkerPipe,
    CommonModule, TranslateModule, GoogleMap, MapMarker, UiPreloaderComponent],
})
export class SharedPanicAlertComponent implements OnInit {
  protected readonly mapProvider: typeof MapProviderModels.Provider = MapProviderModels.Provider;
  private readonly store$ = inject(Store);
  private readonly destroyRef = inject(DestroyRef);

  public readonly loaderColor = PreloaderColor;
  public readonly mapZoom = PANIC_LOCATION_ZOOM;

  public readonly alert = signal<AlertEntry | null>(null);
  public readonly coords = computed<MapCoords | null>(() => extractPanicCoords(this.alert()));

  public ngOnInit(): void {
    this.store$
      .pipe(select(GrantedAccessSelectors.selectSharedAlert), takeUntilDestroyed(this.destroyRef))
      .subscribe((alert) => this.alert.set(alert ?? null));
  }
}
